<div *ngIf="services" class="container-fluid mt-top-end-navbar">
	<div class="row justify-content-md-center">
		<!-- TRANSPORT -->
		<div class="col-12">
			<mat-card class="card border-0 shadow-sm">
				<div class="media border-0">
					<a class="info" href="https://openfiber.it/it/fibra-ottica/occhio-al-bollino" target="_ftth">
						<img
							class="mr-3"
							src="{{ baseService.pathImgsMarkers }}/ftth.png?v={{ assets_version }}"
							alt="FTTH"
						/>
					</a>
					<div class="title-1">
						{{ "SERVICES.TRANSPORT_COLO" | translate }}
					</div>
				</div>

				<ng-container *ngFor="let service of services.transportAndColo">
					<div class="card-body border-0">
						<div class="title-2">
							{{ service.name }}
						</div>
						{{ service.description }}
						<div class="mt-3">
							<ng-container *ngIf="service.name.includes('Wavelength')">
								<ng-container *ngFor="let value of waveValues">
									<span>
										<strong>
											{{ value.type }} standard price (unprotected) with 1 year minimum contract
										</strong>
									</span>
									<div class="my-4 d-flex price-table">
										<div>
											<div class="table-box"></div>
											<div class="table-box table-title">NRC (Non Recurring Charge)</div>
											<div class="table-box table-title">MRC (Monthly Recurring Charge)</div>
										</div>
										<ng-container *ngFor="let v of value.values">
											<div *ngIf="v.prices.cluster === 'AB'">
												<div class="table-box table-title">Urban Area</div>
												<div class="table-box">€ {{ v.prices.nrc }}</div>
												<div class="table-box">€ {{ v.prices.mrc }}</div>
											</div>
											<div *ngIf="v.prices.cluster === 'CD'">
												<div class="table-box table-title">Rural Area</div>
												<div class="table-box">€ {{ v.prices.nrc }}</div>
												<div class="table-box">€ {{ v.prices.mrc }}</div>
											</div>
										</ng-container>
									</div>
								</ng-container>
							</ng-container>

							<ng-container *ngIf="service.name.includes('Colocation')">
								<ng-container *ngFor="let value of coloValues">
									<span>
										<strong>{{ value.type }}</strong>
									</span>
									<div class="my-4 d-flex price-table">
										<div>
											<div class="table-box"></div>
											<div class="table-box table-title">NRC (Non Recurring Charge)</div>
											<div class="table-box table-title">MRC (Monthly Recurring Charge)</div>
										</div>
										<ng-container *ngFor="let v of value.values">
											<div *ngIf="v.prices.cluster === 'AB'">
												<div class="table-box table-title">Urban Area</div>
												<div class="table-box">€ {{ v.prices.nrc }}</div>
												<div class="table-box">€ {{ v.prices.mrc }}</div>
											</div>
											<div *ngIf="v.prices.cluster === 'CD'">
												<div class="table-box table-title">Rural Area</div>
												<div class="table-box">€ {{ v.prices.nrc }}</div>
												<div class="table-box">€ {{ v.prices.mrc }}</div>
											</div>
										</ng-container>
									</div>
								</ng-container>
							</ng-container>

							<p class="vat">{{ "SERVICES.VAT_EXCLUDED" | translate }}</p>
						</div>
					</div>
				</ng-container>
			</mat-card>
		</div>
	</div>
</div>
